<script setup lang="ts">
const emit = defineEmits(['close'])
const props = defineProps<{
  selectedPlansLength?: number
}>()
</script>

<template>
  <div
    class="fixed right-0 bottom-0 left-0 p-4 bg-white border-t border-gray-200"
  >
    <div class="max-w-lg mx-auto flex gap-4">
      <div
        class="mx-auto flex items-center justify-between flex-col gap-2 mt-2"
      >
        <ClickToCall v-slot="{ handleClick }">
          <a
            :href="phone.uri"
            @click="handleClick"
            class="text-lg text-darkBlue font-medium text-center"
          >
            Compare plans and enroll with a licensed insurance agent
          </a>
        </ClickToCall>
        <div class="flex flex-grow items-center gap-4">
          <ClickToCall v-slot="{ handleClick }">
            <a
              v-if="selectedPlansLength && selectedPlansLength > 0"
              :href="phone.uri"
              @click="handleClick"
              class="block p-2 bg-red rounded-md flex gap-2 text-white px-4 items-center shadow-lg"
            >
              <Icon
                i-heroicons-solid:phone
                class="w-5 h-5 animate-shake text-white"
              />
              Call to continue ({{ selectedPlansLength }})
            </a>
            <a
              v-else
              :href="phone.uri"
              @click="handleClick"
              class="block p-2 bg-red rounded-md flex gap-2 text-white px-4 items-center shadow-lg"
            >
              <Icon
                i-heroicons-solid:phone
                class="w-5 h-5 animate-shake text-white"
              />
              {{ phone.formatted }} (TTY 711)
            </a>
          </ClickToCall>
        </div>

        <ClickToCall v-slot="{ handleClick }">
          <a
            :href="phone.uri"
            @click="handleClick"
            class="text-lg text-darkBlue font-medium text-center"
          >
            24/7 Agents available now
          </a>
        </ClickToCall>
      </div>
      <button @click="emit('close')" class="h-5 w-5 absolute top-4 right-2">
        <Icon i-heroicons-solid:x class="w-5 h-5 text-darkBlue" />
      </button>
    </div>
  </div>
</template>
